<template lang="pug">
el-drawer(:title="flowVersion" :visible.sync="flowInstanceHistory" direction="rtl" size="400px" :before-close="logClose")
  .nodeShowList
    .user-steps
      .user-step( v-for="(item, index) in nodeList" :key="index" :title="item.nodeName")
        .top
          .circle
          span {{item.flowNodeName}}{{nodeStatusName(item.nodeStatus)}}
        .description
          .user-title
            span 审批人：
            span.multiUserDealStrategy(v-if="item.assigneeList.length>1") {{item.multiUserDealStrategy===1?"或签":"会签"}}
          //- approverFlow(ref="approverFlow" :info="item" :step="index")
          userListApprove( :userList="changeUserName(item.assigneeList)" disabled v-if="item.assigneeList?.length>0")
          span.expr(v-else) {{item.conditionExpr}}
          .user-title
            span 抄送人：
          userList.outline(ref="userList" line="inline" disabled :jobNo="false" :list="changeUserName(item.ccList)" v-if="item.ccList?.length>0")
          span.noUser(v-else) （无抄送人）
</template>

<script>
import { asyncMixin } from "@/CommonDP/commons/asyncCom.js";
import flowService from "@/CommonDP/service/flow-service";
import userItem from "@/CommonDP/components/chooseMember/userItem.vue";
import userList from "@/CommonDP/components/userList/index.vue";
import approverFlow from "../config/approverFlow.vue";
import userListApprove from "../config/userListApprove.vue";
export default {
  components: {
    userItem, userList, approverFlow, userListApprove
  },
  mixins: [asyncMixin],
  props: {
    flowInstanceId: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      flowVersion: "流程记录",
      flowInstanceHistory: !false,
      nodeList: []
    };
  },
  mounted () {
    this.getFlowInstanceHistory();
  },
  methods: {
    async getFlowInstanceHistory() {
      if (this.flowInstanceId) {
        const res = await flowService.getFlowInstanceHistory(this.flowInstanceId);
        // console.log("流程实例历史记录:", res);
        this.nodeList = res.data || [];
      }
    },

    // 审批人列表 过滤 type=0 审批人 type=1 被抄送人
    approverList(item) {
      return this.changeUserName(item.userDtoList?.filter(e => e.type === 0));
    },
    // 是否显示审批人列表
    showApproveList(item) {
      const list = this.approverList(item);
      return list.length > 0;
    },
    changeUserName(list) {
      return list.map((e) => {
        return {
          ...e,
          selectCode: "User",
          name: e.userName
        };
      });
    },
    nodeStatusName(status) {
      const statusDesccribe = {
        1: () => " (已同意)",
        2: () => " (审批中)",
        3: () => " (发起)",
        4: () => " (再发起)",
        5: () => " (已撤回)",
        0: () => " (已驳回)"
      };
      return statusDesccribe[status] ? statusDesccribe[status]() : "";
    },
    logClose() {
      this.flowInstanceHistory = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.flowSteps {
  width: 100%;
  height: 100%;
  overflow: hidden;
  padding-left: 10px;
}

.nodetitle {
  height: 40px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #ebefff;
  margin-bottom: 10px;

  span {
    font-weight: 700;
    font-size: 16px;
    line-height: 40px;
    color: var(--theme-color);
  }

  i {
    cursor: pointer;
  }
}

.nodeShowList {
  width: 100%;
  height: 100%;
  padding: 5px;
  padding-top: 0;
  overflow-x: hidden;
  overflow-y: auto;
}

.user-steps {
  width: 100%;
  display: flex;
  flex-direction: column;

  .user-step {
    width: 100%;
    overflow-x: hidden;
    display: flex;
    flex-direction: column;

    .top {
      height: 30px;
      display: flex;
      flex-direction: row;
      align-items: center;

      .circle {
        width: 16px;
        height: 16px;
        background-color: #c0c4cc;
        border-radius: 8px;
      }

      span {
        margin-left: 7px;
        font-size: 14px;
        font-weight: 700;
      }
    }

    .description {
      margin-left: 7px;
      border-left: 2px solid #c0c4cc;
      padding-left: 10px;
      display: flex;
      flex-direction: column;

      .user-title {
        font-size: 12px;
        line-height: 20px;
        color: var(--theme-color);
        display: flex;
        flex-direction: row;
        align-items: center;

        .multiUserDealStrategy {
          margin-left: 5px;
          font-size: 12px;
          line-height: 20px;
          color: #606266;
        }
        .addStyleApprove{
          margin-left: 5px;
          font-size: 22px;
          line-height: 20px;
          color: var(--theme-color);
          cursor: pointer;
        }
      }
    }
  }
}

.ischeck {
  /deep/.circle {
    background-color: var(--theme-color) !important;
  }

  /deep/.description {
    border-left: 2px solid var(--theme-color) !important;
  }
}

.outline {
  border: none;
  padding-left: 0 !important;
}

.expr {
  font-size: 14px;
  line-height: 35px;
}
.noUser {
  font-size: 12px;
  color: var(--info-color);
}
.footer {
  margin-top: 10px;
}

.flowInline {
  display: flex;
  flex-direction: row;
  align-items: center;

  .title {
    font-size: 16px;
    line-height: 23px;
    color: var(--theme-color);
  }

  .addPeople {
    margin-left: 5px;
  }
}
</style>
<style lang="scss">
.el-drawer__header{
  margin-bottom: 10px;
}
.el-drawer__header>span{
  font-weight: 700;
  font-size: 15px;
}
</style>
